// src/pages/sms-campaigns/index.jsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Header from "../../components/ui/Header";
import Sidebar from "../../components/ui/Sidebar";
import Breadcrumbs from "../../components/ui/Breadcrumbs";
import Button from "../../components/ui/Button";
import Icon from "../../components/AppIcon";

import SmsComposeModal from "../../components/sms/SmsComposeModal";

export default function SmsCampaignsPage() {
  const { t } = useTranslation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [composeOpen, setComposeOpen] = useState(false);

  const toggleSidebar = () => setSidebarCollapsed((v) => !v);

  return (
    <div className="min-h-screen bg-background">
      <Header isCollapsed={sidebarCollapsed} onToggleSidebar={toggleSidebar} />
      <Sidebar isCollapsed={sidebarCollapsed} onToggle={toggleSidebar} />

      <main
        className={`page-top pb-20 lg:pb-6 transition-all duration-300 ${
          sidebarCollapsed ? "lg:ml-16" : "lg:ml-60"
        }`}
      >
        <div className="p-6">
          <div className="mb-6">
            <Breadcrumbs items={[{ label: t("sms.title") }, { label: t("sms.campaigns.title") }]} />

            <div className="mt-4 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              <div>
                <h1 className="text-3xl font-bold text-foreground">{t("sms.campaigns.title")}</h1>
                <p className="text-text-secondary mt-1">
                  {t("sms.campaigns.subtitle")}
                </p>
              </div>

              <div className="flex">
                <Button
                  variant="outline"
                  onClick={() => setComposeOpen(true)}
                  className="flex items-center gap-2 w-full lg:w-auto justify-center"
                >
                  <Icon name="MessageSquare" size={18} />
                  <span>{t("sms.campaigns.sendTest")}</span>
                </Button>
              </div>
            </div>
          </div>

          <div className="bg-surface border border-border rounded-xl p-4">
            <div className="text-sm text-text-secondary">
              <div className="font-medium text-foreground flex items-center gap-2">
                <Icon name="Construction" size={18} />
                <span>{t("sms.campaigns.roadmap")}</span>
              </div>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>{t("sms.campaigns.roadmapItem1")}</li>
                <li>{t("sms.campaigns.roadmapItem2")}</li>
                <li>{t("sms.campaigns.roadmapItem3")}</li>
                <li>{t("sms.campaigns.roadmapItem4")}</li>
              </ul>
            </div>
          </div>

          <SmsComposeModal isOpen={composeOpen} onClose={() => setComposeOpen(false)} />
        </div>
      </main>
    </div>
  );
}
